import type { ReactNode } from "react"
import type { CustomField } from "@/schema"

export interface CrossReferenceValue {
  target_type?: string
  target_id?: number | string
  target_label?: string
  type?: string
  id?: number | string
  label?: string
}

export function getCrossReferenceData(value: CrossReferenceValue | null) {
  if (!value) return null

  return {
    type: value.target_type || value.type,
    id: value.target_id || value.id,
    label: value.target_label || value.label,
  }
}

export interface CustomFieldInputProps {
  customField: CustomField
  value: unknown
  onSave: (value: unknown) => void
  isLoading: boolean
  label?: string | ReactNode
  fixedLabelWidth?: string
  multiSelectDisplay?: "input" | "pills"
}

export interface CustomFieldFormInputProps {
  customField: CustomField
  value: unknown
  onSave: (value: unknown) => void
  isLoading: boolean
}
